export let TrackerFulfillmentType = /*#__PURE__*/function (TrackerFulfillmentType) {
  TrackerFulfillmentType["PICKUP"] = "pickup";
  TrackerFulfillmentType["DELIVERY"] = "delivery";
  TrackerFulfillmentType["NONE"] = "none";
  return TrackerFulfillmentType;
}({});
//# sourceMappingURL=constants.js.map